export interface ParsedTitleDescription {
  title: string;
  description: string;
}

/**
 * Parses a string into title and description by a given separator.
 * Only splits on the first occurrence of the separator.
 *
 * @param raw - The raw string to parse
 * @param separator - The separator to split by (default: ':')
 * @returns An object with title and description
 *
 * @example
 * parseStringWithSeparator('Title: Description here', ':')
 * // { title: 'Title', description: 'Description here' }
 *
 * parseStringWithSeparator('Title – Description here', '–')
 * // { title: 'Title', description: 'Description here' }
 */
export const parseStringWithSeparator = (
  raw: string,
  separator: string = ':',
): ParsedTitleDescription => {
  const separatorIndex = raw.indexOf(separator);
  if (separatorIndex === -1) {
    return { title: raw.trim(), description: '' };
  }
  return {
    title: raw.slice(0, separatorIndex).trim(),
    description: raw.slice(separatorIndex + separator.length).trim(),
  };
};
